
import { Component, Prop, Vue } from "vue-property-decorator"
import { Getter } from "vuex-class"

@Component({})
export default class NotificationsButton extends Vue {
	@Prop({ type: Number, required: true })
	numberOfNotifications!: number;

	private get notificationNumber () {
		if (this.numberOfNotifications >= 10) {
			return "9+"
		}
		return this.numberOfNotifications.toString()
	}

	private get hasNotifications () {
		return this.numberOfNotifications > 0
	}
}
